import { Navigate, useRoutes } from "react-router-dom"
import LoginView from "../views/login";
import NotFoundView from "../views/404";
import DashboardView from "../views/dashboard";
import { ProtectedRoute } from "./protectedRoute";
import PermissionView from "../views/permission";
import ChangePasswordView from "../views/changePassword";
import AdminAccountView from "../views/adminAccount";
import ProductView from "../views/product";
import CustomerView from "../views/customer";
import CategoryView from "../views/category";
import DriverView from "../views/driver";
import OrderView from "../views/order";
import DriverFinancialView from "../views/driverFinacial";
import SalesReportView from "../views/reports";
import HomeView from "../views/home";
import DeliveryFee from "../views/deliveryFee";
import BannerView from "../views/banner";
import JiffyStaffView from "../views/jiffyStaff";
import BranchManageView from "../views/branchManage";
import PopUpManagementView from "../views/pop-up";
import NotificationView from "../views/notification";
import DriverRiderBonusView from "../views/driverBonus";
import OrderDetailView from "../views/order-detail";
import { ADMIN_ACCOUNT_ROUTE, ADMIN_DETAIL, BANNER_ROUTE, BRANCH_ROUTE, BRAND_ROUTE, CATEGORY_MERCHANT_ROUTE, CHANGE_MONEY_RIDER, CHANGE_PASSWORD_ROUTE, COUPON_HISTORY, COUPON_ROUTE, CUSTOMER_ROUTE, DELIVERY_FEE_MANAGEMENT_ROUTE, DRIVER_BONUS_ROUTE, DRIVER_FINANCIAL_CLEARANCE_ROUTE, DRIVER_REPORT_ROUTE, DRIVER_ROUTE, FORM_DRIVER_REGISTER, HOME_ROUTE, HR_MANAGE, MASTER_CATEGORY_ROUTE, MASTER_PRODUCT_ROUTE, NOTIFICATION_ROUTE, ORDER_DETAIL_ROUTE, ORDER_ROUTE, PAYMENT_REPORT_ROUTE, POPUP_ROUTE, PRODUCT_MERCHANT_ROUTE, PROMOTION_ROUTE, RIDER_BALANCE, RIDER_REPORT, SALES_REPORT_ROUTE, STAFF_ROUTE } from "./paths";
import CouponView from "../views/coupon";
import PromotionView from "../views/promotion";
import ProductMerchantView from "../views/productMerchant";
import CategoryBranchView from "../views/categoryBranch";
import DriverFormRegisterView from "../views/formDriver";
import BrandView from "../views/brand";
import AdminDetailView from "../views/adminDetail";
import RiderReportView from "../views/riderReport";
import CouponHistoryView from "../views/couponHistory";
import RiderBalanceView from "../views/RiderBalance";
import { checkPermission } from "../utils/checkPermission";
import { useSelector } from "react-redux";
import { RootState } from "../store";
import ChangeMoneyRiderTake from "../views/changeMoneyRider";
import HrManagePage from "../views/HR-manage";

export default function Router() {
    const authData = useSelector((state: RootState) => state?.auth?.data);
    return useRoutes([
        {
            path: '/',
            element: <ProtectedRoute><DashboardView /></ProtectedRoute>,
            children: [
                {
                    element: <Navigate to="home" replace />, index: true
                },
                {
                    path: HOME_ROUTE,
                    element: <HomeView />
                },

                {
                    path: ADMIN_ACCOUNT_ROUTE,
                    element: <AdminAccountView />
                },
                {
                    path: CUSTOMER_ROUTE,
                    element: <CustomerView />,
                },
                {
                    path: CHANGE_PASSWORD_ROUTE,
                    element: <ChangePasswordView />
                },

                {
                    path: MASTER_PRODUCT_ROUTE,
                    element: <ProductView />
                },
                {
                    path: PRODUCT_MERCHANT_ROUTE,
                    element: <ProductMerchantView />
                },
                {
                    path: MASTER_CATEGORY_ROUTE,
                    element: <CategoryView />
                },
                {
                    path: CATEGORY_MERCHANT_ROUTE,
                    element: <CategoryBranchView />
                },
                {
                    path: HR_MANAGE,
                    element: <HrManagePage />
                },
                {
                    path: DRIVER_ROUTE,
                    element: <DriverView />
                },
                {
                    path: ORDER_ROUTE,
                    element: <OrderView />
                },
                {
                    path: DRIVER_FINANCIAL_CLEARANCE_ROUTE,
                    element: <DriverFinancialView />,
                },
                {
                    path: SALES_REPORT_ROUTE,
                    element: <SalesReportView />
                },
                {
                    path: DELIVERY_FEE_MANAGEMENT_ROUTE,
                    element: <DeliveryFee />
                },
                {
                    path: BANNER_ROUTE,
                    element: <BannerView />
                },
                {
                    path: STAFF_ROUTE,
                    element: <JiffyStaffView />
                },
                {
                    path: BRANCH_ROUTE,
                    element: <BranchManageView />
                },
                {
                    path: POPUP_ROUTE,
                    element: <PopUpManagementView />
                },
                {
                    path: NOTIFICATION_ROUTE,
                    element: <NotificationView />
                },
                {
                    path: DRIVER_BONUS_ROUTE,
                    element: <DriverRiderBonusView />
                },
                {
                    path: ORDER_DETAIL_ROUTE,
                    element: <OrderDetailView />
                },
                {
                    path: COUPON_ROUTE,
                    element: <CouponView />
                },
                {
                    path: PROMOTION_ROUTE,
                    element: <PromotionView />
                },
                {
                    path: FORM_DRIVER_REGISTER,
                    element: <DriverFormRegisterView />
                },
                {
                    path: BRAND_ROUTE,
                    element: <BrandView />
                },
                {
                    path: ADMIN_DETAIL,
                    element: <AdminDetailView />
                },
                {
                    path: RIDER_REPORT,
                    element: <RiderReportView />
                },
                {
                    path: COUPON_HISTORY,
                    element: <CouponHistoryView />
                },
                {
                    path: RIDER_BALANCE,
                    element: <RiderBalanceView />
                },
                {
                    path: CHANGE_MONEY_RIDER,
                    element: <ChangeMoneyRiderTake />
                }
            ].filter((item) => checkPermission(authData?.role?.role_type ?? "", item?.path ?? ""))
        },
        {
            path: 'auth',
            children: [
                {
                    path: 'login',
                    element: <LoginView />
                }
            ]
        },
        {
            path: "/404",
            element: <NotFoundView />
        },
        { path: '*', element: <Navigate to="/404" replace /> },
    ]);
}